import { ComponentOrdering } from "@kunduz/feature-landing-pages";

export const defaultComponentOrderingFields = {
  orderingDesktop: {
    type: "select",
    label: "Ordering Desktop",
    options: [
      { value: "listVertical", label: "Vertical" },
      { value: "listHorizontal", label: "Horizontal" },
    ],
  },
  orderingTablet: {
    type: "select",
    label: "Ordering Tablet",
    options: [
      { value: "listVertical", label: "Vertical" },
      { value: "listHorizontal", label: "Horizontal" },
    ],
  },
  orderingMobile: {
    type: "select",
    label: "Ordering Mobile",
    options: [
      { value: "listVertical", label: "Vertical" },
      { value: "listHorizontal", label: "Horizontal" },
    ],
  },
};

export const defaultComponentOrdering: {
  OrderingMobile?: ComponentOrdering;
  OrderingTablet?: ComponentOrdering;
  OrderingDesktop?: ComponentOrdering;
} = {
  OrderingMobile: "listVertical",
  OrderingTablet: "listVertical",
  OrderingDesktop: "listVertical",
};
